






































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { SERVICE_PAYMENT_STATUSES } from '@/constants/payment';

@Component({
  computed: {
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderReadOrderReviewTable extends Vue {
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;

  discount(item) {
    const discount = 100 - Math.floor(item._discount_rate * 100);
    return discount + '% off';
  }

  getUnitPriceByCountry(serviceItem) {
    return (
      serviceItem.unit_price[
        this.activeServiceOrder?.business?.country || 'AU'
      ] || serviceItem.unit_price['AU']
    );
  }
}
